export enum OrderStateEnum {
	ALL = 'all',
	OPEN = 'open',
	CANCELED = 'canceled',
	FILLED = 'filled',
	CLOSED = 'closed',
}
